import { FC } from 'react';

import { localeCommon } from '@lib/tools/locale/source/web/common';
import { ILocaleText } from '@lib/tools/locale/views/LocaleFragment';
import { VH_VARIANTS } from '@lib/tools/shared/helpers/consts';

import curiousIcon from '@components/web/src/assets/icons/curious_icon.svg';
import fidelityCardIcon from '@components/web/src/assets/icons/fidelity_card_not_found.svg';
import occasionIcon from '@components/web/src/assets/icons/occasion_icon.svg';
import questionIcon from '@components/web/src/assets/icons/question_icon.svg';
import Button from '@components/web/src/atoms/Buttons/Button';
import { CloseButton } from '@components/web/src/atoms/Buttons/CloseButton/CloseButton';
import { Text } from '@components/web/src/foundations/Text/Text';
import { ModalWrapper } from '@components/web/src/templates/Modals/ModalWrapper/ModalWrapper';
import * as S from '@components/web/src/templates/Modals/ScanResultModal/styles';

export type ScanResultModalIconType = 'Occasion' | 'Curious' | 'Question' | 'FidelityCard';

const iconComponents: Record<ScanResultModalIconType, string> = {
  Curious: curiousIcon,
  FidelityCard: fidelityCardIcon,
  Occasion: occasionIcon,
  Question: questionIcon,
};

interface IProps {
  icon: ScanResultModalIconType;
  title: ILocaleText;
  subtitle: ILocaleText;
  isOpen: boolean;
  withButton: boolean;
  hideModal: () => void;
}

export const ScanResultModal: FC<IProps> = ({
  isOpen,
  title,
  icon = 'Question',
  subtitle,
  withButton = true,
  hideModal,
}) => {
  const { close } = localeCommon.commonMessages;

  return (
    <ModalWrapper isOpen={isOpen} onClose={hideModal}>
      <S.ScanResultModalContainer direction="column" gap={0} padding="16px 16px 24px">
        <CloseButton handleClick={hideModal} position="right" />
        <S.ContentWrapper align="center" direction="column" gap={8} padding="0 14px">
          <img alt="icon" src={iconComponents[icon]} />
          {title && <Text size="h6" text={title} textAlign="center" weight="semibold" />}
          <Text size="subtitle1" text={subtitle} textAlign="center" weight="medium" />
          {withButton && (
            <Button
              fontSize="subtitle1"
              size="lg"
              text={close}
              textWeight="medium"
              variant={VH_VARIANTS.PRIMARY}
              onClick={hideModal}
            />
          )}
        </S.ContentWrapper>
      </S.ScanResultModalContainer>
    </ModalWrapper>
  );
};
